import { GET_TENANT_STATISTICS,  GET_TENANT_STATISTICS_SUCCESS,  CLEAR_TENANT_STATISTICS, CLEAR_TENANT_STATISTICS_SUCCESS } from './constants';

/**
 *
 * @param data
 * @returns {{data: *, type: string}}
 */
const getTenantStatistics = ( data ) => ( {
    type: GET_TENANT_STATISTICS,
    data
} );

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const getTenantStatisticsSuccess = ( result ) => ( {
    type:  GET_TENANT_STATISTICS_SUCCESS,
    result
} );
/**
 *
 * @returns {{type: string}}
 */
const clearReducer = () => ( {
    type: CLEAR_TENANT_STATISTICS
} );
/**
 *
 * @returns {{type: string}}
 */
const clearReducerSuccess = () => ( {
    type: CLEAR_TENANT_STATISTICS_SUCCESS
} );

export { clearReducer,  clearReducerSuccess, getTenantStatistics, getTenantStatisticsSuccess };